module.exports = __webpack_public_path__ + "img/HomeGraphic.df5cfa7d.jpg";